import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatBadgeModule } from '@angular/material/badge';
import { CellRenderer, CellRendererParams } from 'app/shared/components/smart-grid/core/interfaces/cell-renderer.interface';
import { VisitAttributes } from '@albatrosdeveloper/ave-models-package';

/**
 * Visit Images Cell Renderer
 *
 * Renders a photo_library icon with a badge showing the count of visit images.
 * Opens an image carousel when clicked.
 *
 * @example
 * ```typescript
 * {
 *   headerName: 'Imágenes',
 *   cellRenderer: VisitImagesCellRendererComponent,
 *   cellRendererParams: {
 *     onOpenCarousel: (images) => this.openImageCarousel(images)
 *   },
 *   sortable: false,
 *   minWidth: 100,
 *   colId: 'visitImages'
 * }
 * ```
 */
@Component({
  selector: 'app-visit-images-cell-renderer',
  standalone: true,
  imports: [
    CommonModule,
    MatIconModule,
    MatTooltipModule,
    MatBadgeModule,
  ],
  template: `
    <mat-icon
      color="primary"
      class="pointer-icon mr-3"
      [matBadge]="imageCount"
      matBadgeColor="accent"
      matBadgeSize="small"
      [matTooltip]="tooltipText"
      (click)="onIconClick($event)">
      photo_library
    </mat-icon>
  `,
  styles: [`
    .pointer-icon {
      cursor: pointer;
    }
  `]
})
export class VisitImagesCellRendererComponent implements CellRenderer<VisitAttributes> {
  @Input() params!: CellRendererParams<VisitAttributes>;

  get imageCount(): number {
    return this.params.data?.visitImages?.length || 0;
  }

  get tooltipText(): string {
    return this.imageCount > 0 ? 'Ver imágenes' : 'Sin imágenes';
  }

  onIconClick(event: Event): void {
    event.stopPropagation();
    const onOpenCarousel = (this.params as any).onOpenCarousel;
    if (onOpenCarousel && this.params.data?.visitImages) {
      onOpenCarousel(this.params.data.visitImages);
    }
  }
}
